import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Play, Calendar, Tv } from 'lucide-react';

interface VideoCardProps {
  title: string;
  network: string;
  date: string;
  thumbnail: string;
  videoId: string;
  topic: string;
}

const VideoCard = ({ title, network, date, thumbnail, videoId, topic }: VideoCardProps) => {
  const handlePlay = () => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, '_blank');
  };

  return (
    <Card className="group cursor-pointer transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-2xl bg-white border-2 hover:border-blue-500">
      <CardContent className="p-0">
        <div className="relative overflow-hidden rounded-t-lg">
          <img 
            src={thumbnail} 
            alt={title}
            className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
            <Play 
              className="text-white w-16 h-16 group-hover:scale-125 transition-transform duration-300 drop-shadow-lg" 
              onClick={handlePlay}
            />
          </div>
          <Badge className="absolute top-3 right-3 bg-red-600 hover:bg-red-700">
            <Tv className="w-3 h-3 mr-1" />
            {network}
          </Badge>
        </div>
        <div className="p-4">
          <h3 className="font-bold text-lg mb-2 line-clamp-2 group-hover:text-blue-600 transition-colors">
            {title}
          </h3>
          <div className="flex items-center text-gray-600 text-sm mb-2">
            <Calendar className="w-4 h-4 mr-1" />
            {date}
          </div>
          <Badge variant="outline" className="text-xs">
            {topic}
          </Badge>
        </div>
      </CardContent>
    </Card>
  );
};

export default VideoCard;